// src/components/JobSearchLoader.tsx
import React from 'react';
import Lottie from 'lottie-react';
import Header from '../Header'; // Your existing header


const JobSearchLoader = () => {
  return (
    <>
      <Header />
      <div className="fixed inset-0 bg-gradient-to-br from-blue-50 to-purple-50 flex items-center justify-center z-50">
        <div className="text-center">
          <div className="relative w-64 h-64 mx-auto mb-8">
            {/* Simple SVG human figures */}
            <svg viewBox="0 0 200 200" className="w-full h-full animate-pulse">
              <circle cx="100" cy="100" r="90" fill="#6366f1" opacity="0.2" />
              <path d="M100 20 Q 140 60 100 100 Q 60 140 100 180" stroke="#4f46e5" strokeWidth="8" fill="none" />
            </svg>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="text-5xl font-bold text-indigo-600 animate-bounce">🔍</div>
            </div>
          </div>
          <h2 className="text-3xl font-bold text-indigo-800">Searching for jobs near you...</h2>
          <p className="text-lg text-indigo-600 mt-4">Hang tight! Great opportunities are loading...</p>
        </div>
      </div>
    </>
  );
};
export default JobSearchLoader;



